var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apex-chart',{attrs:{"type":"polarArea","options":_vm.chartOptions,"series":_vm.series,"width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }